import { useId, type InputHTMLAttributes } from 'react';

export interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  readonly label: string;
  readonly error?: string;
}

/** Labelled input; the error is announced and linked with aria-describedby. */
export function TextField({ label, error, ...rest }: TextFieldProps) {
  const id = useId();
  const errId = `${id}-err`;
  return (
    <div className="skm-field">
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? errId : undefined}
        {...rest}
      />
      {error ? (
        <p id={errId} role="alert" className="skm-field__error">
          {error}
        </p>
      ) : null}
    </div>
  );
}
